/**
 * Helpers for reading the API error shape { error_code, title, message }.
 *
 * Only the numeric code is used to pick a message: server-side texts are never
 * rendered, so nothing about the backend leaks into the UI.
 */

export const API_ERROR_CODE = {
  THROTTLED: 4290,
  CODE_INCORRECT: 4001,
  CODE_EXPIRED: 4002,
  CODE_BLOCKED: 4004,
  // The password reset step reuses 4001/4002 for the reset_token.
  TOKEN_INCORRECT: 4001,
  TOKEN_EXPIRED: 4002,
};

export function getApiErrorCode(error: any): number | undefined {
  const code = error?.response?.data?.error_code;
  return typeof code === "number" ? code : undefined;
}

export function isThrottledError(error: any): boolean {
  return (
    error?.response?.status === 429 ||
    getApiErrorCode(error) === API_ERROR_CODE.THROTTLED
  );
}
